/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
var isType = require('./is-type');

var isArguments = function isArguments(value) {
  return isType(value, 'Arguments');
};

module.exports = isArguments;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-arguments.js
// module id = 320
// module chunks = 0 1 2